<template>
  <div id="contenedor-main-adjudicacion">
    <v-container fluid>
      <v-card flat class="mb-4">
        <v-card-text>
          <v-toolbar flat>
            <v-btn icon @click="regresar">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-toolbar-title class="display-1">
              {{ getTitulo }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              v-if="mixValidaScopesActions(2)"
              color="primary"
              class="ml-3"
              small
              @click="mostrarVentanaEditarAdjudicacionDirecta = true">
              <v-icon left small>mdi-pencil</v-icon>
              Editar
            </v-btn>
          </v-toolbar>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text>
          <router-view
            :key="$route.params.idAdjudicacion"
            :adjudicacion-directa="getAdjudicacion"
            :cargando-adjudicacion="cargandoAdjudicacion"></router-view>
        </v-card-text>
      </v-card>

      <v-dialog
        v-if="getAdjudicacion.id"
        v-model="mostrarVentanaEditarAdjudicacionDirecta"
        :width="!$vuetify.breakpoint.mobile ? '80%' : '90%'">
        <editar-adjudicacion-directa
          :adjudicacionDirectaEditar="getAdjudicacion"
          @actualizado="recargarAdjudicacion"
          @cerrar="cerrarEditarAdjudicacionDirecta">
        </editar-adjudicacion-directa>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import ADJUDICACION_DIRECTA from '@/graphql/querys/administracion/adjudicaciones/adjudicacion.gql';
import EditarAdjudicacionDirecta from '@/components/administracion/adjudicaciones/Editar.vue';

export default {
  name: 'MainAdjudicacion',
  components: {
    EditarAdjudicacionDirecta,
  },
  data() {
    return {
      mostrarVentanaEditarAdjudicacionDirecta: false,
      adjudicacionDirecta: null,
      cargandoAdjudicacion: false,
    };
  },
  watch: {
    '$route.params.idAdjudicacion': function idAdjudicacionCambiado() {
      this.recargarAdjudicacion();
    },
  },
  mounted() {
    this.recargarAdjudicacion();
  },
  computed: {
    getAdjudicacion() {
      if (!this.adjudicacionDirecta) return {};
      return this.adjudicacionDirecta;
    },
    getTitulo() {
      return this.getAdjudicacion.numeroContrato || 'Ficha de Adjudicacion';
    },
  },
  methods: {
    async recargarAdjudicacion() {
      const { idAdjudicacion } = this.$route.params;
      if (!idAdjudicacion) return;

      this.cargandoAdjudicacion = true;
      this.adjudicacionDirecta = null;

      try {
        const { data } = await this.$apollo.query({
          query: ADJUDICACION_DIRECTA,
          fetchPolicy: 'no-cache',
          variables: {
            id: String(idAdjudicacion),
          },
        });

        this.adjudicacionDirecta = data && data.adjudicacionDirecta
          ? data.adjudicacionDirecta
          : null;
      } finally {
        this.cargandoAdjudicacion = false;
      }

      this.cerrarEditarAdjudicacionDirecta();
    },
    cerrarEditarAdjudicacionDirecta() {
      this.mostrarVentanaEditarAdjudicacionDirecta = false;
    },
    regresar() {
      this.$router.push({ name: 'adjudicaciones' });
    },
  },
};
</script>

<style lang="scss">
</style>
